<template>
  <!-- 点検値参照 -->
  <div id="AppPrescriptionView">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column is-full">
          <label class="searchTitle label">点検値参照</label>
        </div>
      </div>
      <div style="margin-left: 50px; margin-Right: 50px;">
        <!-- 詳細表示 -->
        <div style="detailArea">
          <section>
            <div style="height:10px;"></div>
            <table class="table" style="width: 100%;">
              <tr style="font-size: 16px;">
                <td style="width: 200px;">患者コード</td>
                <td>{{ inspectionItem.patientCode }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>患者名</td>
                <td>{{ inspectionItem.patientName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>医療機関</td>
                <td>{{ inspectionItem.hospitalName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>診療科</td>
                <td>{{ inspectionItem.department }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>担当医</td>
                <td>{{ inspectionItem.doctorName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>品目名</td>
                <td>
                  <span
                    v-if="inspectionItem.machineReplaceProductCode && inspectionItem.machineReplaceProductCode!=inspectionItem.productCode"
                  >{{ inspectionItem.machineReplaceProductName }} ⇒</span>
                  {{ inspectionItem.productName }}
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>シリアル</td>
                <td>
                  <span
                    v-if="inspectionItem.machineReplaceSerialNumber"
                  >{{ inspectionItem.machineReplaceSerialNumber }} ⇒</span>
                  {{ inspectionItem.serialNumber }}
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>処方値変更理由</td>
                <td>
                  <table>
                    <thead style="border-bottom: 3px double lightgray">
                      <tr>
                        <td style="font-size: 16px;width:14%;">変更日時</td>
                        <td style="font-size: 16px;width:14%;">更新者</td>
                        <td style="font-size: 16px;width:10%;">変更種別</td>
                        <td style="font-size: 16px;width:14%;">変更項目</td>
                        <td style="font-size: 16px;width:10%;">変更前</td>
                        <td style="font-size: 16px;width:10%;">変更後</td>
                        <td style="font-size: 16px;width:28%;">変更理由
                          <b-button
                            class="button is-primary has-text-centered"
                            native-type="button"
                            style="float: right;left:14px;"
                            icon-left="history"
                            v-on:click="prescriptionHistoryModalActive=true"
                          >処方値変更履歴</b-button>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="lastPreEditHistory">
                        <td style="font-size: 16px;">{{ lastPreEditHistory.updatedDay }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.staffName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.type }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.displayName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.beforeValue }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.afterValue }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.doctorChangeReason }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 8">
                <td>療法（呼吸のみ）</td>
                <td>{{ therapy }}</td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 7 && hardwareVersion > 0">
                <td>メイン設定</td>
                <td>{{inspectionItem.mainSetting != null ? trilogyEvoMainSetting.find(elem => elem.code == inspectionItem.mainSetting).name : ""}}</td>
              </tr>
            </table>
            <div class="columns" style="width: 100%;"></div>
            <div style="height:10px;"></div>
            <div class="columns header">
              <div class="column is-1" style="text-align:left;">No.</div>
              <div class="column is-3" style="text-align:left; margin-left:10px;">点検内容</div>
              <div class="column is-4" style="text-align:left; margin-left:10px;">処方値</div>
              <div class="column is-3.2" style="text-align:left; margin-left:10px;">点検値</div>
            </div>
            <template
              v-for="(content, index) in inspectionItem.value"
            >
              <!-- 見出し表示共通化 -->
              <template v-if="header(content)">
                <heading-comp
                  v-for="(header, headerIndex) in header(content)"
                  :key="'header-' + index + '-' + headerIndex"
                  :color="'backgroundColor: ' + header.backgroundColor"
                  text-style="font-size:15px; font-weight: bold; color:white;"
                  :prefix="header.getPrefix ? header.getPrefix(inspectionItem.mainSetting, content.contentsType) : ''"
                  :value1="header.headerName"
                  style="margin-bottom: 0.75rem"
                ></heading-comp>
              </template>

              <div
                class="columns row"
                v-bind:key="index"
              >
                <div class="column is-1" style="text-align:left; margin-left:10px;">{{index + 1}}</div>
                <div class="column is-3" style="text-align:left; margin-left:10px;">
                  <span v-if="content.displayName">
                    {{ displayName(content) }}
                    <br />
                  </span>
                  {{ content.content }}
                  <span
                    v-if="content.displayName == '携帯用酸素ボンベ（本数）' && bombeSerialList && bombeSerialList.length > 0"
                  >
                    <br />シリアルNo(酸素ボンベ)
                  </span>
                </div>

                <template v-if="content.type=== 'char'">
                  <div
                    class="column is-4"
                    style="text-align:left; margin-left:10px; white-space:pre-line;"
                  >{{ getPrescriptionValue(content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                  <div class="column is-3.2" style="text-align:left; margin-left:10px;">
                    <span
                      style="word-break: break-all;white-space: pre-line"
                    >{{content.value }} {{isShowUintLabel(content.value, content.unit)}}</span>
                    <span
                      v-if="content.displayName == '携帯用酸素ボンベ（本数）' && bombeSerialList && bombeSerialList.length > 0"
                    >
                      <br />
                      <span v-for="(item, subIndex) in bombeSerialList" v-bind:key="subIndex">
                        <br />
                        シリアル（{{subIndex+1}}）{{item.value}}
                      </span>
                    </span>
                    <span
                      v-if="content.displayName == '処方値変更理由'"
                    ></span>
                  </div>
                </template>

                <template v-if="content.type=== 'sel'">
                  <div
                    class="column is-4"
                    style="text-align:left; margin-left:10px;"
                  >{{ getSelectValue(content.displayValue,content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                  <div class="column is-3.2" style="text-align:left; margin-left:10px;">
                    <span>{{ selectedValue(content.value, content.displayValue) }} {{ isShowUintLabel(content.value, content.unit) }}</span>
                  </div>
                </template>
                <template v-if="content.type=== 'radio'">
                  <div class="column is-4" style="text-align:left; margin-left:10px;" />
                  <div class="column is-3.2" style="text-align:left; margin-left:10px;">
                    <b-radio
                      v-for="displayValue in content.displayValue"
                      v-model="displayValue.key"
                      :value="displayValue.value"
                      :key="displayValue.key"
                      :native-value="content.value"
                      :name="getRadioFieldName(index)"
                      :disabled="true"
                    >{{displayValue.value}}</b-radio>
                  </div>
                </template>

                <template v-if="content.type=== 'text'">
                  <div class="column is-4" style="text-align:left; margin-left:10px;" />
                  <div class="column is-3.2" style="text-align:left; margin-left:10px;">
                    <span>{{content.value}}</span>
                    <span
                      style="margin-left:10px;"
                      v-if="content.unit"
                    >{{isShowUintLabel(content.value, content.unit)}}</span>
                  </div>
                </template>
              </div>
            </template>
          </section>
          <div style="height: 24px;" />
          <div class="columns row" style="backgroundColor: #000894;height: 25px;">
            <div style="text-align:left; margin-left:10px;">
              <span style="font-size:15px; font-weight: bold; color:white;">消耗品メモ</span>
            </div>
          </div>
          <div
            class="columns row"
            v-for="(content, index) in disposableMemoList"
            v-bind:key="index"
            style="width:100%;"
          >
            <div style="width:9%;padding-top: 15px;">{{"消耗品"+(index+1)}}</div>
            <div style="width:20%;padding-top: 10px;margin-left:5px">
              <b-field>
                <b-input
                  :name="'name'+index"
                  :id="'id'+index"
                  data-vv-as="消耗品"
                  :field="'field'+index"
                  expanded
                  v-model="content.disposableCodeMemo"
                  :readonly="roleId==2"
                  v-validate="'checkProduct'"
                  @select="option => {content.disposableCodeMemo = option.disposableCodeMemo;
                errors.remove('name'+index)}"
                ></b-input>
                <b-button
                  class="button is-primary has-text-centered"
                  native-type="button"
                  id="index"
                  :disabled="roleId==2"
                  v-on:click="changeProduct(index)"
                >検索</b-button>
              </b-field>
            </div>
            <b-field
              :type="{'is-danger': errors.has('name'+index)}"
              :message="errors.first('name'+index)"
              style="width:45%;padding-top: 15px;text-align:left;padding-left:3%"
            >
              <div>{{content.disposableCodeMemo | disposableFilter(productMaster)}}</div>
            </b-field>
            <div style="width:18%;padding-top:10px;padding-left:3px;">
              <b-field>
                <b-datepicker
                  v-if="roleId!=2"
                  :name="'preDate'+index"
                  :id="'preDateId'+index"
                  data-vv-as="供給日"
                  v-model="content.supplyDateMemo"
                  placeholder="供給日"
                  icon="calendar-today"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                >
                  <button class="button is-danger" @click="setDateNull(content)">
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
                </b-datepicker>
                <b-input v-else :readonly="true" v-model="content.supplyDateMemo"></b-input>
              </b-field>
            </div>
            <div style="width:10%;padding-top:10px;margin-left:5px;">
              <b-field>
                <b-input
                  :name="'count'+index"
                  :id="'countId'+index"
                  data-vv-as="個数"
                  min="0"
                  max="999"
                  maxlength="3"
                  expanded
                  :readonly="roleId==2"
                  v-model="content.disposableCountMemo"
                ></b-input>
                <span style="margin-left:2px;padding-top:10px">EA</span>
              </b-field>
            </div>
          </div>
          <b-modal :active.sync="isSelectProductActive" has-modal-card>
            <selectProduct-form v-bind:index="targetItem.index" v-on:set-Product="setProduct"></selectProduct-form>
          </b-modal>
          <b-modal :active.sync="prescriptionHistoryModalActive" has-modal-card full-screen>
            <prescription-history-modal v-bind:targetData="preEditHistoryList"></prescription-history-modal> 
          </b-modal>
        </div>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        v-if="roleId!=2"
        v-on:click="saveMemo"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >消耗品メモ登録</b-button>
      <div style="height: 350px;" />
    </div>
  </div>
</template>

<script>
var inspectionItem = {};
import Quagga from "quagga";
import selectProductTemplate from "./AppSelectProduct";
import * as inspectionUtil from "../utils/inspection"

const selectProductform = {
  methods: {
    select: function() {
      var item = this.$refs.filteredProduct.getProduct();
      // 選択結果を画面に反映
      if (item) {
        this.$emit("set-Product", item);
        this.$parent.close();
      }
    }
  },
  components: {
    selectProduct: selectProductTemplate
  },
  props: ["index"],
  template: `
      <form action="">
        <div class="modal-card" style="width: 800px;">
         <header class="modal-card-head">
           <p class="modal-card-title" style="color: whitesmoke;">消耗品選択</p>
         </header>         
        　<section class="modal-card-body">
          　<selectProduct ref="filteredProduct" v-bind:index="index" v-bind:productMasterflg="true"/>
          </section>
          <footer class="modal-card-foot">
            <div class="column is-full" style="text-align:center;">
              <b-button
                v-on:click=$parent.close()
                class="button"
                type="is-primary"
                icon-left="keyboard-backspace"
                native-type="button"
                >戻る</b-button>
              <b-button
                v-on:click="select()"
                class="button"
                type="is-primary"
                icon-left="content-save"
                native-type="button"
                >選択</b-button>
            </div>
          </footer>
        </div>
      </form>
    `
};

const HeadingCompTemplate = {
  props: ["index", "color", "value1", "textStyle", "prefix"],
  template: `
  <div class="columns row" :style="color">
      <div class="column is-1" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{prefix}}</span>
      </div>
      <div class="column is-3" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value1}}</span>
      </div>
      <div class="column is-4" style="text-align:left; margin-left:10px;">
      </div>
      <div class="column is-3.2" style="text-align:left; margin-left:10px;">
      </div>
  </div>
  `,
  data: function() {
    return {};
  },
  created: function() {},
  methods: {}
};

import prescriptionHistoryModal from "./AppPrescriptionHistoryModal";
export default {
  name: "AppPrescriptionView",
  computed: {
    hardwareVersion: function() {
      let hardwareVersion = 0;
      if (inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion) {
        hardwareVersion = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion(this.inspectionItem.value);
      }
      return hardwareVersion;
    },
  },

  methods: {
    setDateNull: function(disposable) {
      disposable.supplyDateMemo = null;
    },
    getProductName: function(value) {
      var deliveryElement = this.productMaster.find(
        v => v.productCode === value
      );
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    },
    saveMemo: function() {
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          var excuteApi = this.setInspectionOtherMemo;
          var successCallBack = this.setInspectionOtherMemoSuccess;
          var errorCallBack = this.setInspectionOtherMemoError;
          // WebAPI Call
          return this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    setInspectionOtherMemo: function(client) {
      var memoData = {};
      for (var i = 0; i < this.disposableMemoList.length; i++) {
        var disposableCode = "disposableCodeMemo" + String(i + 1);
        var disposableCount = "disposableCountMemo" + String(i + 1);
        var supplyDate = "supplyDateMemo" + String(i + 1);
        memoData[disposableCode] = this.disposableMemoList[i].disposableCodeMemo
          ? this.disposableMemoList[i].disposableCodeMemo
          : null;
        memoData[disposableCount] = this.disposableMemoList[i]
          .disposableCountMemo
          ? this.disposableMemoList[i].disposableCountMemo
          : null;
        memoData[supplyDate] = this.disposableMemoList[i].supplyDateMemo
          ? this.formatDate2(this.disposableMemoList[i].supplyDateMemo).replace(
              /\//g,
              ""
            )
          : null;
      }
      memoData.patientCode = this.inspectionItem.patientCode;
      memoData.productCode = this.inspectionItem.productCode;
      memoData.serial = this.inspectionItem.serialNumber;
      memoData.reservationId = this.appointmentCode;
      memoData.editType = "1";
      memoData.freeMemo = null;

      var obj = JSON.parse(JSON.stringify(memoData));
      return client.apis.apiInspection.setInspectionOtherMemoPOST({
        body: obj
      });
    },
    setInspectionOtherMemoSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back(event);
    },
    setInspectionOtherMemoError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setProduct: function(item) {
      this.disposableMemoList[this.targetItem.index].disposableCodeMemo = item;

      //エラーリセット
      this.errors.remove("name" + this.targetItem.index);

      this.targetItem = {
        index: null
      };
    },
    changeProduct: function(index) {
      this.isSelectProductActive = true;
      this.targetItem.index = index;
    },
    sortedItemsByDisplayOrder(value) {
      // displayOrderでソート
      return value.sort((a, b) => {
        return a.displayOrder < b.displayOrder
          ? -1
          : a.displayOrder > b.displayOrder
          ? 1
          : 0;
      });
    },
    back: function(event) {
      // 点検一覧
      this.$router.push({
        name: "AppInspectionSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    selectedValue: function(value, options) {
      var optionElement = options.find(v => v.key === value);
      if (optionElement) {
        return optionElement.value;
      }
      return "";
    },
    getMachineValuePOST: function(client) {
      return client.apis.apiInspection.getMachineValuePOST({
        body: {
          code: this.inspectionItem.inspectionCode,
          productCode: this.inspectionItem.productCode,
          patientCode: this.inspectionItem.patientCode,
          serial: this.inspectionItem.serialNumber,
          type: 1,
          refMode: true,
        }
      });
    },
    getMachineValuePOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      var bombe;
      for (var cnt = 0; cnt < result.obj.length; cnt++) {
        if (Object.keys(result.obj[cnt]).indexOf("bombeSerialList") != -1) {
          bombe = result.obj[cnt].bombeSerialList;
          break;
        }
      }

      //機器種別の取得;
      this.machineType = result.obj.find(
        item => Object.keys(item).indexOf("reportFormatType") != -1
      ).reportFormatType;

      // 不要項目「reportFormatType」の削除
      result.obj = result.obj.filter(
        item => Object.keys(item).indexOf("reportFormatType") == -1
      );

      if (bombe) {
        this.bombeSerialList = bombe;
        this.$delete(result.obj, cnt);
      }
      var target = result.obj.filter(val => {
        if(this.machineType == 11){
          if(val.displayName.indexOf('(プリセット4)') != -1 || 
          val.displayName.indexOf('(プリセット5)') != -1 || 
          val.displayName.indexOf('(プリセット6)') != -1 ||
          val.displayName.indexOf('(プリセット7)') != -1 ||
          val.displayName.indexOf('(プリセット8)') != -1 ||
          val.displayName.indexOf('(プリセット9)') != -1 ){
            return false
          }
        }
        if(val.displayName != "処方値変更理由"){
        return Object.keys(val).indexOf("displayOrder") != -1;
        }
      });
      var others = result.obj.filter(val => {
        return Object.keys(val).indexOf("targetMemo") != -1;
      });

      var cnt = 1;
      var completionEditDate = this.completionDate
        .substring(0, 10)
        .replace(/\//g, "");

      var firstTimeFlag = true;
      if (others && others.length > 0) {
        // 消耗品メモを設定
        var other = others[0];
        for (var i = 0; i < 10; i++) {
          var disposableCodeMemo = "disposableCodeMemo" + String(cnt);
          var supplyDateMemo = "supplyDateMemo" + String(cnt);
          var disposableCountMemo = "disposableCountMemo" + String(cnt);
          var dateMemo = this.parseDate2(other[supplyDateMemo]);
          if (this.roleId == 2) {
            dateMemo = this.formatDate2(dateMemo);
          }
          this.disposableMemoList.push({
            disposableCodeMemo: other[disposableCodeMemo],
            disposableCountMemo: other[disposableCountMemo],
            supplyDateMemo: dateMemo
          });
          cnt = cnt + 1;
          if (
            other[disposableCodeMemo] != null ||
            other[disposableCountMemo] != null ||
            other[supplyDateMemo] != null
          ) {
            firstTimeFlag = false;
          }
        }
        //点検その他情報レコードは存在するが、消耗品メモを登録してない場合
        if (firstTimeFlag) {
          this.disposableMemoList = [];
          var dateMemo = this.parseDate2(completionEditDate);
          if (this.roleId == 2) {
            dateMemo = this.formatDate2(dateMemo);
          }
          for (var i = 0; i < 10; i++) {
            this.disposableMemoList.push({
              disposableCodeMemo: null,
              disposableCountMemo: null,
              supplyDateMemo: dateMemo
            });
          }
        }
      } else {
        //点検その他情報レコードが無い場合
        var dateMemo = this.parseDate2(completionEditDate);
        if (this.roleId == 2) {
          dateMemo = this.formatDate2(dateMemo);
        }
        for (var i = 0; i < 10; i++) {
          this.disposableMemoList.push({
            disposableCodeMemo: null,
            disposableCountMemo: null,
            supplyDateMemo: dateMemo
          });
        }
      }
      this.inspectionItem.value = target;
      this.sortedItemsByDisplayOrder(this.inspectionItem.value);
      var simplyList = [
        "シンプリーゴーミニ",
        "オプション拡張バッテリー　有無",
        "シンプリーゴー",
        "シンプリーゴー予備バッテリ"
      ];
      for (var i in this.inspectionItem.value) {
        if (
          simplyList.indexOf(this.inspectionItem.value[i].displayName) != -1
        ) {
          var val;
          switch (this.inspectionItem.value[i].value) {
            case "X":
              this.inspectionItem.value[i].value = "1";
              break;
            case "0":
            case "1":
              break;
            default:
              this.inspectionItem.value[i].value = "0";
              break;
          }
        }
      }
      // 処方値変更履歴取得
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiInspection.getPrescriptionHistoryListPOST({
            body:{
              productCode: _this.inspectionItem.productCode,
              patientCode: _this.inspectionItem.patientCode,
              serial: _this.inspectionItem.serialNumber,
            }
          });
    },
        function(result) {
          // 検索結果取得
          _this.preEditHistoryList = result.obj
          if(_this.preEditHistoryList.length > 0){
            _this.lastPreEditHistory = _this.preEditHistoryList[_this.preEditHistoryList.length-1]
          }
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },
    getMachineValuePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getRadioFieldName: function(index) {
      return "radio" + index;
    },
    check: function(item, resultValue) {
      if (item.value === resultValue) {
        return true;
      } else {
        return false;
      }
    },
    getPrescriptionValue(value) {
      if (value == "-" || value == "null") {
        return "";
      } else {
        return value;
      }
    },
    getSelectValue(displayValue, prescription) {
      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key === prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    getErrorMsg(preTarget, countTarget) {
      var target;

      target = this.errors.items.find(
        v => v.field == preTarget || v.field == countTarget
      );
      if (target) {
        return target.msg;
      }
      return "";
    },
    isShowUintLabel(value, unit) {
      let ret = "";
      if (value && value != "-") {
        ret = unit;
      }
      return ret;
    },
    displayName: function (content) {
      let name = content.displayName;
      switch (this.machineType) {
        case inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code:
          if (content.contentsType) {
            name = "【設定" + content.contentsType + "】" + name;
          }
          break;
      
        default:
          break;
      }

      return name;
    },

    header: function(content) {
      let header
      if (content.contentsType) {
        if (inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion) {
          header = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType][this.hardwareVersion][content.contentsType][content.displayOrder];
        } else {
          header = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType][content.contentsType][content.displayOrder];
        }
      }

      return header;
    },
  },
  data() {
    var productMaster = [];
    this.getProductList(productMaster);
    var inspectionCode = this.$route.params["code"];
    var productCode = this.$route.params["productCode"];
    var productName = this.$route.params["productName"];
    var serialNumber = this.$route.params["serialNumber"];
    var appointmentCode = this.$route.params["appointmentCode"];
    var completionDate = this.$route.params["completionDate"];
    var machineReplaceProductCode = this.$route.params[
      "machineReplaceProductCode"
    ];
    var machineReplaceSerialNumber = this.$route.params[
      "machineReplaceSerialNumber"
    ];
    var machineReplaceProductName = this.$route.params[
      "machineReplaceProductName"
    ];
    var patientCode = this.$route.params["patientCode"];
    var patientName = this.$route.params["patientName"];
    var hospitalName = this.$route.params["hospitalName"];
    var department = this.$route.params["department"];
    var doctorName = this.$route.params["doctorName"];
    var searchConditions = this.$route.params["searchConditions"];
    var therapy = this.$route.params["therapy"];
    var bombeSerialList = [];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
      inspectionItem: {
        inspectionCode,
        productCode,
        productName,
        serialNumber,
        machineReplaceProductCode,
        machineReplaceSerialNumber,
        machineReplaceProductName,
        patientCode,
        patientName,
        hospitalName,
        department,
        doctorName,
        mainSetting: this.$route.params.mainSetting,
        value: [],
        bombeSerialList
      },
      searchConditions,
      disposableMemoList: [],
      isSelectProductActive: false,
      targetItem: {
        index: null
      },
      appointmentCode,
      productMaster,
      completionDate,
      roleId,
      therapy,
      machineType: null,
      preEditHistoryList: [],
      prescriptionHistoryModalActive:false,
      lastPreEditHistory:{},
      trilogyEvoMainSetting: inspectionUtil.TRILOGY_EVO_SETTING,
    };
  },
  mounted: function() {
    var excuteApi = this.getMachineValuePOST;
    var successCallBack = this.getMachineValuePOSTSuccess;
    var errorCallBack = this.getMachineValuePOSTError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  filters: {
    disposableFilter: function(value, disposablesMaster) {
      var product = disposablesMaster.find(v => v.productCode === value);
      if (product) {
        return product.productName + " (" + product.productCode + ")";
      }
      return "";
    }
  },
  components: { 
    "selectProduct-form": selectProductform,
    "prescription-history-modal": prescriptionHistoryModal,
    "heading-comp": HeadingCompTemplate,
  },
  created: function() {
    this.$validator.extend("checkDuplication", {
      getMessage: field => `消耗品コードが重複しています。`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        var disposableList = this.disposableMemoList.filter(
          v => v.disposableCodeMemo == value
        );
        // 消耗品リストでの品目コード重複をチェック
        if (disposableList.length > 1) {
          var ret = false;
        }
        return ret;
      }
    });
    this.$validator.extend("checkProduct", {
      getMessage: field => `入力された消耗品コードは存在しません。`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        if (this.getProductName(value) == "") {
          var ret = false;
        }
        return ret;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: double;
}
.row {
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPrescriptionView.vue